import * as React from 'react';
import { __ } from 'react-i18n';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { SecondStep } from './Summary/SecondStep';
import { ThirdStep } from './Summary/ThirdStep';

interface Props {
  step: number;
  handleStepChange: (step: number) => void;
  data: any;
  handleAcceptTermsChange: (e: any) => void;
  isFetching: boolean;
  freeDel: number | null;
}

function CartSummary({
  step,
  handleStepChange,
  data,
  handleAcceptTermsChange,
  isFetching,
  freeDel,
}: Props) {
  return (
    <>
      {step === 2 || step === 3 ? (
        <Wrapper>
          <Title>{__('Sumár')}</Title>
          {step === 2 && (
            <SecondStep
              isFetching={isFetching}
              data={data}
              handleStepChange={handleStepChange}
              freeDel={freeDel}
            />
          )}
          {step === 3 && (
            <ThirdStep
              isFetching={isFetching}
              handleAcceptTermsChange={handleAcceptTermsChange}
              data={data}
              handleStepChange={handleStepChange}
              freeDel={freeDel}
            />
          )}
        </Wrapper>
      ) : null}
    </>
  );
}

const Wrapper = styled(FlexCol)`
  width: ${rem(328)};
  margin-left: ${rem(16)};

  align-self: flex-start;
  position: sticky;
  top: ${rem(130)};

  ${({ theme }) => theme.mediab.l925`
    margin: ${rem(16)} auto 0;
    width: initial;
    max-width: ${rem(328)};
    position: static;
    top: initial;
  `}
`;

const Title = styled(TextP)`
  font-size: ${rem(24)};
  font-family: ${({ theme }) => theme.font.secondary};
  color: black;
  line-height: ${rem(28)};
  margin-bottom: ${rem(32)};
  font-weight: 500;
`;

export { CartSummary };
